import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title: string;
  titleId?: string;
  desc?: string;
  descId?: string;
  color?: string;
  ariaHidden?: boolean;
  iconSize: 's' | 'm' | 'l' | 'inherit';
  style?: React.CSSProperties;
}
const svgContent = (
  props: React.SVGProps<SVGSVGElement>,
  title?: string,
  titleId?: string,
  desc?: string,
  descId?: string
) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    color="currentColor"
    role="img"
    aria-labelledby={titleId}
    aria-describedby={descId}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M20.4853 19.0753L13.4142 12.0043L20.4853 4.93319C20.6728 4.74565 20.7782 4.4913 20.7782 4.22608C20.7782 3.96086 20.6728 3.70651 20.4853 3.51897C20.2977 3.33144 20.0434 3.22608 19.7782 3.22608C19.513 3.22608 19.2586 3.33144 19.0711 3.51897L12 10.59L4.92893 3.51897C4.7414 3.33144 4.48704 3.22608 4.22183 3.22608C3.95661 3.22608 3.70226 3.33144 3.51472 3.51897C3.32718 3.70651 3.22183 3.96086 3.22183 4.22608C3.22183 4.4913 3.32718 4.74565 3.51472 4.93319L10.5858 12.0043L3.51472 19.0753C3.32718 19.2629 3.22183 19.5172 3.22183 19.7824C3.22183 20.0476 3.32718 20.302 3.51472 20.4895C3.70226 20.6771 3.95661 20.7824 4.22182 20.7824C4.48704 20.7824 4.7414 20.6771 4.92893 20.4895L12 13.4185L19.0711 20.4895C19.2586 20.6771 19.513 20.7824 19.7782 20.7824C20.0434 20.7824 20.2977 20.6771 20.4853 20.4895C20.6728 20.302 20.7782 20.0476 20.7782 19.7824C20.7782 19.5172 20.6728 19.2629 20.4853 19.0753Z"
      fill="currentColor"
    />
  </svg>
);
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  color,
  ...props
}: SVGRProps) => {
  const sizes = {
    s: '12px',
    m: '16px',
    l: '24px',
    inherit: 'inherit', // inherits size from parent
  };
  const size = sizes[iconSize] || 'inherit';
  const style = {
    width: size,
    height: size,
    display: 'flex',
    color: color, // Use the color prop for the icon color
  };
  return (
    <div
      style={style}
      aria-hidden={ariaHidden}
      id={descId ? descId : titleId} // Choose one ID based on what's available
      {...props}
    >
      {svgContent(props, title, titleId, desc, descId)}
    </div>
  );
};
const SvgCross = SvgIcon;
export default SvgCross;
